export enum AdditionalFeatureAccept {
  NONE = 'none',
  YES = 'yes',
  NO = 'no'
}
